export enum PerformSyncState {
    SyncCompleted = 'Sync-Completed',
    SyncFailed = 'Sync-Failed',
    InProgress = 'in-progress',
    Changed = 'changed',
}